export const MODULE_KEYS = {
    DASHBOARD_USER_OVERVIEW: "DASHBOARD_USER_OVERVIEW",
    DASHBOARD_JOB_OVERVIEW: "DASHBOARD_JOB_OVERVIEW",

    PROVIDER_MANAGEMENT_LISTING: "PROVIDER_MANAGEMENT_LISTING",
    PROVIDER_PROFILE_DETAIL: "PROVIDER_PROFILE_DETAIL",
    PROVIDER_JOB_DETAIL: "PROVIDER_JOB_DETAIL",
    PROVIDER_PROMOTION_DETAIL: "PROVIDER_PROMOTION_DETAIL",
    PROVIDER_RATING_REVIEWS: "PROVIDER_RATING_REVIEWS",
    SEEKER_MANAGEMENT_LISTING: "SEEKER_MANAGEMENT_LISTING",
    SEEKER_PROFILE: "SEEKER_PROFILE",
    SEEKER_CARE_PROFILE: "SEEKER_CARE_PROFILE",
    SEEKER_RATING_REVIEWS: "SEEKER_RATING_REVIEWS",
    JOB_MANAGEMENT_LISTING: "JOB_MANAGEMENT_LISTING",
    JOB_MANAGEMENT_DETAIL: "JOB_MANAGEMENT_DETAIL",
    USER_MANAGEMENT_LISTING: "USER_MANAGEMENT_LISTING",

    CATEGORIES_MANAGEMENT: "CATEGORIES_MANAGEMENT",
    SUB_CATEGORIES_MANAGEMENT: "SUB_CATEGORIES_MANAGEMENT",

    //unused

    PROVIDER_MANAGEMENT_CREATE: "PROVIDER_MANAGEMENT_CREATE",
    CATEGORY_MANAGEMENT_DETAILS: "CATEGORY_MANAGEMENT_DETAILS",
    COURSE_MANAGEMENT_LISTING: "COURSE_MANAGEMENT_LISTING",
    ADD_COURSE: "ADD_COURSE",
    DETAIL_COURSE: "DETAIL_COURSE",
    COURSE_STATUS: "COURSE_STATUS",
    UPDATE_COURSE: "UPDATE_COURSE",
    COURSE_MANAGEMENT_ROUNDS_LISTING: "COURSE_MANAGEMENT_ROUNDS_LISTING",
    AD_MANAGEMENT_LISTING: "AD_MANAGEMENT_LISTING",
    ACCOUNT_CHANGE_PASSWORD: "ACCOUNT_CHANGE_PASSWORD",
    PROFILE_UPDATED: "PROFILE_UPDATE",
    USER_DETAILS_PROFILE: "USER_DETAILS_PROFILE",
    USER_DETAILS_ROUNDS: "USER_DETAILS_ROUNDS",
    USER_DETAILS_CONNECTIONS: "USER_DETAILS_CONNECTIONS",
    DASHBOARD_ROUNDS: "DASHBOARD_ROUNDS",
    DASHBOARD_ANALYTICS: "DASHBOARD_ANALYTICS",
    DASHBOARD_GRAPH: "DASHBOARD_GRAPH",
    CONTENT_DETAILS: "CONTENT_DETAILS",
    UPDATE_USER: "UPDATE_USER",
    CREATE_AD: "CREATE_AD",
    UPDATE_AD: "UPDATE_AD",
    UPDATE_CONTENT: "UPDATE_CONTENT",
    DELETE_CONTENT: "DELETE_CONTENT",
    DELETE_USER: "DELETE_USER",
    DELETED_USER: "DELETED_USER",
    ARTICLE_REORDER: "ARTICLE_REORDER"
};

export const getKey = (keys = [], params = {}) => {
    const KEYS = [...keys];

    const hasParams = Object.keys(params);

    if (hasParams.length) {
        KEYS.push(params);
    }

    return KEYS;
};
